<template>
  <div class="card_content">
    <!-- 検索条件 -->
    <div class="search-box">
      <v-row no-gutters align="center">
        <v-col class="mr-1" cols="2">
          <v-select
            v-model="selectedKndNm"
            :items="InfoKind"
            label="お知らせ種別"
          ></v-select>
        </v-col>
        <v-col class="mr-1" cols="1">
          <v-select
            v-model="selectedArea"
            :items="Area"
            label="地方"
            :menu-props="{ maxHeight: 200, overflowY: true }"
          ></v-select>
        </v-col>
        <v-col class="mr-1" cols="1">
          <v-select
            v-model="selectedTarget"
            :items="tInfo"
            label="お知らせ対象"
          ></v-select>
        </v-col>

        <v-col class="pa-0" cols="12" sm="6" md="4">
          <v-select
            v-if="selectedTarget !== undefined && selectedTarget !== null"
            v-model="selectedDivision"
            :items="infoDivItem"
            small-chips
            label="お知らせ分類"
            multiple
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="tmToggle">
                <v-list-item-action>
                  <v-icon
                    :color="
                      selectedDivision.length > 0 ? 'indigo darken-4' : ''
                    "
                    >{{ tmIcon }}</v-icon
                  >
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>全て選択</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <div class="box-search">
        <v-btn
          outlined
          color="black"
          :loading="searchStatus === 2"
          :disabled="searchStatus === 2"
          @click="getRsltListInfo()"
        >
          <v-icon left>search</v-icon>
          <span>検索</span>
        </v-btn>
      </div>
    </div>
    <div v-show="listCount === 0 && searchStatus === 3" class="listCount">
      対象となるお知らせはありません。
    </div>
    <!-- 結果一覧 -->

    <ul class="list-head">
      <li class="inf-knd">お知らせ種別</li>
      <li class="area">地方</li>
      <li class="target">対象</li>
      <li class="summary">分類</li>
      <li class="announce-time">発表日時</li>
      <li class="summary-title">概要</li>
    </ul>

    <div class="rslt-box" v-show="searchStatus === 3">
      <div class="rslt-list">
        <ul class="info-table">
          <li
            v-for="info in infoDispList.infoList"
            :key="info.infoManageCode"
            @click="getInfoDetail(info.infoManageCode)"
            class="list-item"
          >
            <ul class="data">
              <li class="inf-knd">{{ info.infoKindName }}</li>
              <li class="area">{{ info.areaName }}</li>
              <li class="target">{{ info.target }}</li>
              <li class="summary">{{ info.summaryCode }}</li>
              <li class="announce-time">{{ info.announceTime }}</li>
              <li class="summary-title">{{ info.summary }}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import PageLog from "./../../../lib/pageLog.js";
import mixin from "./../../../lib/mixin.js";
export default {
  name: "if-search",
  mixins: [mixin],
  data() {
    return {
      // 絞り込み条件
      selectedKndNm: null,
      selectedArea: null,
      selectedTarget: null,
      selectedDivision: [],
      // お知らせ種別
      InfoKind: [
        {
          value: null,
          text: "全て",
        },
        {
          value: "1",
          text: "システム関連",
        },
        {
          value: "2",
          text: "観測データ関連",
        },
        {
          value: "3",
          text: "緊急お知らせ",
        },
      ],
      Area: [
        {
          value: null,
          text: "全て",
        },
        {
          value: "80",
          text: "全国",
        },
        {
          value: "81",
          text: "北海道",
        },
        {
          value: "82",
          text: "東北",
        },
        {
          value: "83",
          text: "関東",
        },
        {
          value: "84",
          text: "北陸",
        },
        {
          value: "85",
          text: "中部",
        },
        {
          value: "86",
          text: "近畿",
        },
        {
          value: "87",
          text: "中国",
        },
        {
          value: "88",
          text: "四国",
        },
        {
          value: "89",
          text: "九州",
        },
        {
          value: "90",
          text: "沖縄",
        },
      ],
      // お知らせ対象
      tInfo: [
        {
          value: null,
          text: "全て",
        },
        {
          value: 1,
          text: "観測所",
        },
        {
          value: 2,
          text: "レーダー",
        },
      ],
      // お知らせ分類
      division: {
        1: [
          {
            value: 1,
            text: "メンテナンス",
          },
          {
            value: 2,
            text: "閉局",
          },
          {
            value: 3,
            text: "欠測・未受信",
          },
          {
            value: 4,
            text: "異常値",
          },
          {
            value: 5,
            text: "その他",
          },
        ],
        // お知らせ分類（レーダー）
        2: [
          {
            value: 11,
            text: "メンテナンス（点検）",
          },
          {
            value: 12,
            text: "異常表示",
          },
          {
            value: 13,
            text: "欠測",
          },
          {
            value: 14,
            text: "その他",
          },
        ],
      },
      // 変換後お知らせ一覧
      infoDispList: [],
      // お知らせ件数
      listCount: null,
    };
  },

  mounted() {
    // 一覧情報を取得
    let infQuery = Object.assign({}, this.$route.query);
    // URLパラメータのセット
    if (infQuery.infKnd !== undefined) {
      this.selectedKndNm = infQuery.infKnd;
    }
    if (infQuery.area !== undefined) {
      this.selectedArea = infQuery.area;
    }
    if (infQuery.trgt !== undefined) {
      if (infQuery.trgt === null) {
        this.selectedTarget = infQuery.trgt;
      } else {
        (this.selectedTarget = parseInt(infQuery.trgt)),
          this.$nextTick().then(() => {
            if (infQuery.dvs !== undefined) {
              var param = new Array();
              if (Array.isArray(infQuery.dvs)) {
                infQuery.dvs.forEach((val) => {
                  param.push(parseInt(val));
                });
              } else {
                param.push(parseInt(infQuery.dvs));
              }
              this.selectedDivision = param;
            }
          });
      }
    }
    // お知らせ一覧取得
    this.$nextTick().then(() => {
      this.getRsltListInfo();
    });
  },
  computed: {
    /**
     * お知らせ一覧
     */
    rsltListInfo: {
      get() {
        return {
          infoList: this.$store.state.info.rsltListInfo,
          infoCnt: this.$store.state.info.infoCnt,
        };
      },
    },
    /** 検索状態 */
    searchStatus: {
      get() {
        return this.$store.state.info.searchStatus;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTime,
          infoParam: this.$store.state.info.infoParam,
        };
      },
    },

    infoDivItem() {
      return this.division[this.selectedTarget];
    },
    allClassify() {
      if (
        this.division[this.selectedTarget] === null ||
        this.division[this.selectedTarget] === undefined
      ) {
        return;
      }
      const division = Object.keys(this.division[this.selectedTarget]);
      if (division === null || division === undefined) {
        return;
      }
      return this.selectedDivision.length === division.length;
    },
    partialClassify() {
      return this.selectedDivision.length > 0 && !this.allClassify;
    },
    tmIcon() {
      if (this.allClassify) {
        return "check_box";
      }
      if (this.partialClassify) {
        return "indeterminate_check_box";
      }
      return "check_box_outline_blank";
    },
  },
  watch: {
    // お知らせ一覧の変更の監視
    rsltListInfo() {
      this.setInfoList();
    },
    selectedTarget() {
      this.selectedDivision = [];
    },
  },
  methods: {
    setInfoList() {
      // 変換後お知らせ一覧
      this.infoDispList = this.$store.getters["info/getInfoList"];
      this.listCount = this.rsltListInfo.infoCnt;
    },
    /**
     * お知らせ一覧取得
     */
    getRsltListInfo() {
      // アクセスログ出力
      PageLog.log({
        page_log: "info",
        device_sb: "pc",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$store.dispatch("info/getRsltListInfo", {
        appTime: this.reqParam.appTime,
        infoKndCd: this.selectedKndNm,
        areaCd: this.selectedArea,
        target: this.selectedTarget,
        summaryCd: this.selectedDivision,
      });
      this.$router.replace({
        path: this.$route.path,
        query: {
          fld: this.$store.state.app.fldCtlParty,
          infKnd: this.selectedKndNm,
          area: this.selectedArea,
          trgt: this.selectedTarget,
          dvs: this.selectedDivision,
        },
      });
    },
    tmToggle() {
      this.$nextTick(() => {
        if (this.allClassify) {
          this.selectedDivision = [];
        } else {
          let list = this.division[this.selectedTarget].map((obj) => obj.value);
          this.selectedDivision = list.slice();
        }
      });
    },
    /**
     * お知らせ一覧のレコードクリック
     */
    getInfoDetail(infoManageCd) {
      /**
       * お知らせ詳細画面遷移
       */
      this.routerPushPcInfoDetail("info/detail", infoManageCd);
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.card_content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;

  .search-box {
    display: flex;
    width: 100%;
    .box-search {
      display: flex;
      align-items: center;
      min-width: 80px;
      margin-right: 12px;
    }
  }

  .listCount {
    font-size: 0.9rem;
    color: #e93838;
  }
  .list-head {
    padding: 16px 0px;
    font-size: 0.8rem;
    border-bottom: 1px solid #ddd;
    color: rgba(0, 0, 0, 0.6);
    display: flex;
    overflow: hidden;
    .inf-knd {
      min-width: 200px;
    }
    .area {
      min-width: 80px;
    }
    .target {
      min-width: 88px;
    }
    .summary {
      min-width: 160px;
    }
    .announce-time {
      min-width: 146px;
    }
    .summary-title {
      flex: 1;
    }
  }
  .rslt-box {
    position: relative;

    height: 100%;
    .rslt-list {
      position: absolute;
      overflow-x: auto;
      overflow-y: auto;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      .info-table {
        width: 100%;
        color: rgba(0, 0, 0, 0.6);
        .list-item {
          height: 100%;
          cursor: pointer;
          .data {
            font-size: 0.9rem;
            min-width: 800px;
            padding: 16px 0px;
            border-bottom: 1px solid #ddd;
            display: flex;
            .inf-knd {
              min-width: 200px;
            }
            .area {
              min-width: 80px;
            }
            .target {
              min-width: 88px;
            }
            .summary {
              min-width: 160px;
            }
            .announce-time {
              min-width: 146px;
            }
            .summary-title {
              flex: 1;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}
</style>
